import { Socket } from 'rete';
export default new Socket('Multiplexed video');
